/**
 * EXP-01G — Shared inspiration-to-BME field mapper.
 *
 * Used by gallery card "Plan Like This" (ExplorePage) and
 * event story "Plan One Like This" (EventStoryPage).
 *
 * FindEventsPage keeps its own local copy (frozen EXP-01E).
 * This version is identical — do NOT diverge.
 */

const BME_EVENT_TYPES_VALID = new Set([
  'WEDDING','ENGAGEMENT','BIRTHDAY','CORPORATE',
  'CONFERENCE','PRODUCT_LAUNCH','AWARDS','OTHER',
]);
const BME_ET_LABELS = {
  WEDDING:       'Wedding',
  ENGAGEMENT:    'Engagement',
  BIRTHDAY:      'Birthday',
  CORPORATE:     'Corporate Event',
  CONFERENCE:    'Conference',
  PRODUCT_LAUNCH:'Product Launch',
  AWARDS:        'Award Ceremony',
  OTHER:         'Something Else',
};
const INSP_SCOPE_TO_BME  = { END_TO_END:'END_TO_END', PARTIAL:'CUSTOM', CONSULTATION:'CUSTOM' };
const INSP_STYLE_TO_BME  = {
  Elegant:'ELEGANT', Traditional:'TRADITIONAL', Floral:'FLORAL',
  Royal:'LUXURY',    Grand:'LUXURY',    Luxury:'LUXURY', Glamorous:'LUXURY',
  Modern:'CONTEMPORARY', Vibrant:'VIBRANT', Minimal:'MINIMAL',
};
const INSP_SVC_TO_BME = {
  'Venue':'VENUE', 'Decor & Styling':'DECOR', 'Catering':'CATERING',
  'Photography':'PHOTOGRAPHY', 'Entertainment':'ENTERTAINMENT',
  'AV & Production':'AV_PRODUCTION', 'Logistics':'TRANSPORT',
  'Guest Logistics':'GUEST_HOSPITALITY', 'Floristry':'DECOR',
};
const INSP_GUEST_TO_BME = {
  '50_150':  { v:'UNDER_100', d:'Under 100'   },
  '150_300': { v:'100_250',   d:'100 – 250'   },
  '300_500': { v:'250_500',   d:'250 – 500'   },
  '500_750': { v:'500_750',   d:'500 – 750'   },
  '750_PLUS':{ v:'750_1000',  d:'750 – 1,000' },
};

/**
 * Map raw inspiration transferable fields → BME journey field shape.
 * All mapped fields are tagged INSPIRATION_SUGGESTED / confirmed=false.
 */
export function mapInspirationToJourneyFields(fields) {
  const result = {};

  if (fields.event_type && BME_EVENT_TYPES_VALID.has(fields.event_type)) {
    result.event_type = {
      value: fields.event_type,
      label: BME_ET_LABELS[fields.event_type],
      source: 'INSPIRATION_SUGGESTED',
      confirmed: false,
    };
  }

  const bmeScope = INSP_SCOPE_TO_BME[fields.planning_scope];
  if (bmeScope) {
    result.planning_scope = { value: bmeScope, source: 'INSPIRATION_SUGGESTED', confirmed: false };
  }

  if (fields.style_tags?.length > 0) {
    const mapped = [...new Set(fields.style_tags.map(t => INSP_STYLE_TO_BME[t]).filter(Boolean))];
    if (mapped.length > 0) {
      result.style_preferences = { value: mapped, source: 'INSPIRATION_SUGGESTED', confirmed: false };
    }
  }

  if (fields.services?.length > 0) {
    const valid = [...new Set(fields.services.map(s => INSP_SVC_TO_BME[s]).filter(Boolean))];
    if (valid.length > 0) {
      result.service_interests = { value: valid, source: 'INSPIRATION_SUGGESTED', confirmed: false };
    }
  }

  const gm = INSP_GUEST_TO_BME[fields.guest_range];
  if (gm) {
    result.guest_count_range = { value: gm.v, display: gm.d, source: 'INSPIRATION_SUGGESTED', confirmed: false };
  }

  return result;
}
